import { Traducible } from "./traducible";

export class Formula {
    constructor(params=undefined) {
        if (params) {
            this.idFormula = params.idFormula;
            this.idCliente = params.idCliente;
            this.nombreDes = params.nombreDes;
            this.nombreDesTraducible = params.nombreDesTraducible;
            this.desactivado = params.desactivado;
            this.activo = params.activo;
        }
    }
    idFormula: number;
    idCliente: number;
    nombreDes: string;
    nombreDesTraducible: Traducible;
    desactivado: boolean = true;
    activo: boolean;

    selected: boolean;   //Se usa en el front en formula-select.component
}